<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	     -->
			<!-- School  -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">School</label>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false || UserLevelID != 1"
						value="1"
						label="All Schools"
						[(ngModel)]="SelectedGroupValue"
					></p-radioButton>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false"
						value="2"
						label="Current School Only"
						[(ngModel)]="SelectedGroupValue"
					></p-radioButton>
				</div>
			</div>

			<!-- 	     -->
			<!-- CODE    -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Code</label>
				</div>

				<div style="margin-left: 10px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rInfractionCD"
						maxlength="50"
						style="width: 350px"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 50 characters</label>
				</div>
			</div>
			<!-- 	     	 -->
			<!-- Description -->
			<!-- 	     	 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Description</label>
				</div>

				<div style="margin-left: 10px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rInfractionDesc"
						maxlength="100"
						style="width: 350px"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--  	   	                   -->
			<!-- Infraction Group Selector -->
			<!-- 		             	   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Infraction Group</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedInfractionGroupSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true"
						[(ngModel)]="SelectedInfractionGroup"
						(ngModelChange)="onInfractionGroupChange($event)"
					>
						<option *ngFor="let r of lstInfractionGroupItems" [ngValue]="r">
							{{ r.InfractionGroupDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	                   -->
			<!-- Infraction Level Selector -->
			<!-- 		             	   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Level</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedInfractionLevelSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true || isLimitedEdit == true"
						[(ngModel)]="SelectedInfractionLevel"
						(ngModelChange)="onInfractionLevelChange($event)"
					>
						<option *ngFor="let r of lstInfractionLevelItems" [ngValue]="r">
							{{ r.InfractionLevelDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	         				-->
			<!-- Is Weapon Type / Is Classroom -->
			<!-- 		        				-->
			<div class="column-item">
				<div>
					<label style="margin-left: 85px">Add weapon type</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsWeaponType" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Can be added from Classroom</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsEDCRAssignable" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>
			</div>

			<div class="column-item">
				<!--------------------------------------------------------------------------------------------------->
				<!--SBM-->
				<!--------------------------------------------------------------------------------------------------->

				<div>
					<label style="margin-left: 20px">Out of School Suspension NOT Allowed</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rOutOfSchoolAllowed" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Student Fair Access Criteria Met</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox
						[(ngModel)]="rStudentFairAccess"
						[binary]="true"
						[disabled]="isViewOnly == true"
						(ngModelChange)="onSFAOptionChange($event)"
					></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Email Care Team</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rEmailCareTeam" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Bullying</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rIsBullying" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Emotional Distress Required</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rEmotionalDistress" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<div>
					<label style="margin-left: 20px">Bodily Injury Required</label>
				</div>

				<div style="margin-left: 10px">
					<p-checkbox [(ngModel)]="rBodilyInjury" [binary]="true" [disabled]="isViewOnly == true"></p-checkbox>
				</div>

				<!--------------------------------------------------------------------------------------------------->
			</div>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 		  -->
<!-- ASSIGNED ACTIONS -->
<!-- 		 		  -->
<div class="main-action-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRemove()" [disabled]="isViewOnly == true">Remove</button>
			<img class="info-img" (click)="onToggleInfo1()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Assigned Actions</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo1 == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned Actions: {{ lstInfractionPenaltyItems.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display Assigned     -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstInfractionPenaltyItems"
				[paginator]="true"
				[(rows)]="pagerows1"
				[(first)]="pagefirst1"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedInfractionPenalty"
				dataKey="PenaltyID"
				(onSort)="onHandleSort1($event)"
				(onRowSelect)="onRowSelect1($event)"
				(onRowUnselect)="onRowUnselect1($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="isPrimary" class="fixwidth-08">Default<p-sortIcon field="isPrimary"></p-sortIcon></th>
						<th pSortableColumn="PenaltyCD">Code<p-sortIcon field="PenaltyCD"></p-sortIcon></th>
						<th pSortableColumn="PenaltyDesc">Description<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
						<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
						<th pSortableColumn="WorkflowTypeID">Suspension Type<p-sortIcon field="WorkflowTypeID"></p-sortIcon></th>
						<th pSortableColumn="AllowPartial" class="fixwidth-09">Partial Day Suspension<p-sortIcon field="AllowPartial"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rPenaltyItem>
					<tr [pSelectableRow]="rPenaltyItem">
						<td class="fixwidth-08">
							<div>
								<p-checkbox
									[(ngModel)]="rPenaltyItem.isPrimary"
									[binary]="true"
									(onChange)="onChangePrimary(rPenaltyItem)"
									[disabled]="isViewOnly == true"
								></p-checkbox>
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyCD }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc" style="font-weight: bold" [ngStyle]="{ color: rPenaltyItem.FontColor }">
								{{ rPenaltyItem.Message }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.SchoolID <= 0,
									'table-color-def-4': rPenaltyItem.SchoolID > 0
								}"
							>
								{{ rPenaltyItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.DefinedByID == 1,
									'table-color-def-2': rPenaltyItem.DefinedByID == 2,
									'table-color-def-3': rPenaltyItem.DefinedByID == 3,
									'table-color-def-4': rPenaltyItem.DefinedByID == 4
								}"
							>
								{{ rPenaltyItem.DefinedByDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.WorkflowTypeDesc }}
							</div>
						</td>

						<td>
							<div class="fixwidth-09">
								<i
									class="pi"
									[ngClass]="{
										'pi-check-circle table-active': rPenaltyItem.AllowPartial,
										'pi-ban table-inactive': !rPenaltyItem.AllowPartial
									}"
								></i>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstInfractionPenaltyItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No actions assigned...</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- ACTIONS -->
<!-- 		 -->
<div class="main-action-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onAssign()" [disabled]="isViewOnly == true">Assign</button>
			<img class="info-img" (click)="onToggleInfo2()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Actions</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo2 == true ? 'block' : 'none'">
			<label>&#9900; Total Actions: {{ lstPenaltyItems.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 				 -->
		<!-- Display Actions -->
		<!-- 				 -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtActions
				[value]="lstPenaltyItems"
				[paginator]="true"
				[(rows)]="pagerows2"
				[(first)]="pagefirst2"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedPenalty"
				dataKey="PenaltyID"
				(onSort)="onHandleSort2($event)"
				(onRowSelect)="onRowSelect2($event)"
				(onRowUnselect)="onRowUnselect2($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 				-->
					<!-- Filter Section -->
					<!-- 				-->
					<tr>
						<th>
							<p-columnFilter type="text" field="PenaltyCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="PenaltyDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="SchoolsDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterSchoolsDesc
										[ngModel]="value"
										[options]="lstSchoolsDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th class="fixwidth-12">
							<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterDefinedByDesc
										[ngModel]="value"
										[options]="lstDefinedByDescs"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th>
							<p-columnFilter field="WorkflowTypeDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterWorkflowTypeDesc
										[ngModel]="value"
										[options]="lstWorkflowTypeDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th>
							<p-columnFilter field="AllowPartialDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterAllowPartialDesc
										[ngModel]="value"
										[options]="lstAllowPartialDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="PenaltyCD">Code<p-sortIcon field="PenaltyCD"></p-sortIcon></th>
						<th pSortableColumn="PenaltyDesc">Description<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
						<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
						<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
						<th pSortableColumn="WorkflowTypeID">Suspension Type<p-sortIcon field="WorkflowTypeID"></p-sortIcon></th>
						<th pSortableColumn="AllowPartial" class="fixwidth-09">Partial Day Suspension<p-sortIcon field="AllowPartial"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rPenaltyItem>
					<tr [pSelectableRow]="rPenaltyItem">
						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyCD }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.PenaltyDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc" style="font-weight: bold" [ngStyle]="{ color: rPenaltyItem.FontColor }">
								{{ rPenaltyItem.Message }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.SchoolID <= 0,
									'table-color-def-4': rPenaltyItem.SchoolID > 0
								}"
							>
								{{ rPenaltyItem.SchoolsDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data-Desc fixwidth-12"
								[ngClass]="{
									'table-color-def-1': rPenaltyItem.DefinedByID == 1,
									'table-color-def-2': rPenaltyItem.DefinedByID == 2,
									'table-color-def-3': rPenaltyItem.DefinedByID == 3,
									'table-color-def-4': rPenaltyItem.DefinedByID == 4
								}"
							>
								{{ rPenaltyItem.DefinedByDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rPenaltyItem.WorkflowTypeDesc }}
							</div>
						</td>

						<td>
							<div class="fixwidth-09">
								<i
									class="pi"
									[ngClass]="{
										'pi-check-circle table-active': rPenaltyItem.AllowPartial,
										'pi-ban table-inactive': !rPenaltyItem.AllowPartial
									}"
								></i>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstPenaltyItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No actions configured...</label>
		</div>
	</div>
</div>

<!------------------------------------------------------------------------------------------------------------------------------->
<!--SBM-->
<!------------------------------------------------------------------------------------------------------------------------------->

<!-------------------------------------------------------------->
<!-- 			 		-->
<!-- Sample Infractions -->
<!-- 		 			-->

<!--Assigned-->
<div class="main-action-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRemoveSample()" [disabled]="isViewOnly == true">Remove</button>
			<img class="info-img" (click)="onToggleInfo3()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Assigned Infraction Examples</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo3 == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned Examples: {{ lstAssignedInfractionSample.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display Assigned     -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstAssignedInfractionSample"
				[paginator]="true"
				[(rows)]="pagerows3"
				[(first)]="pagefirst3"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedAssignedInfractionSample"
				dataKey="InfractionSampleID"
				(onSort)="onHandleSort3($event)"
				(onRowSelect)="onRowSelect3($event)"
				(onRowUnselect)="onRowUnselect3($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="InfractionSampleDesc">Description<p-sortIcon field="InfractionSampleDesc"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Used By<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rInfractionSample>
					<tr [pSelectableRow]="rInfractionSample">
						<td>
							<div class="table-data-Desc">
								{{ rInfractionSample.InfractionSampleDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rInfractionSample.SchoolsDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstAssignedInfractionSample.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No examples assigned...</label>
		</div>
	</div>
</div>

<!--Unassigned-->
<div class="main-action-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onAssignSample()" [disabled]="isViewOnly == true">Assign</button>
			<img class="info-img" (click)="onToggleInfo4()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Infraction Samples</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo4 == true ? 'block' : 'none'">
			<label>&#9900; Total Infraction Samples: {{ lstUnassignedInfractionSample.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 				 -->
		<!-- Display Actions -->
		<!-- 				 -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtActions
				[value]="lstUnassignedInfractionSample"
				[paginator]="true"
				[(rows)]="pagerows4"
				[(first)]="pagefirst4"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedUnassignedInfractionSample"
				dataKey="InfractionSampleID"
				(onSort)="onHandleSort4($event)"
				(onRowSelect)="onRowSelect4($event)"
				(onRowUnselect)="onRowUnselect4($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="InfractionSampleDesc">Description<p-sortIcon field="InfractionSampleDesc"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Used By<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rInfractionSample>
					<tr [pSelectableRow]="rInfractionSample">
						<td>
							<div class="table-data-Desc">
								{{ rInfractionSample.InfractionSampleDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rInfractionSample.SchoolsDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstUnassignedInfractionSample.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No infraction samples configured...</label>
		</div>
	</div>
</div>

<!-------------------------------------------------------------->

<!-------------------------------------------------------------->
<!-- 			 					-->
<!-- Student Fair Access Criteria 	-->
<!-- 		 						-->

<!--Assigned-->
<div class="main-action-group" *ngIf="rStudentFairAccess == true">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRemoveSFA()" [disabled]="isViewOnly == true">Remove</button>
			<img class="info-img" (click)="onToggleInfo5()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Assigned Student Fair Access Criteria</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo5 == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned Student Fair Access Criterias: {{ lstAssignedStudentFairAccessCriteria.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display Assigned     -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstAssignedStudentFairAccessCriteria"
				[paginator]="true"
				[(rows)]="pagerows5"
				[(first)]="pagefirst5"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedAssignedStudentFairAccess"
				dataKey="StudentFairAccessCriteriaID"
				(onSort)="onHandleSort5($event)"
				(onRowSelect)="onRowSelect5($event)"
				(onRowUnselect)="onRowUnselect5($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="StudentFairAccessCriteriaDesc">Description<p-sortIcon field="StudentFairAccessCriteriaDesc"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Used By<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rSFA>
					<tr [pSelectableRow]="rSFA">
						<td>
							<div class="table-data-Desc">
								{{ rSFA.StudentFairAccessCriteriaDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rSFA.SchoolsDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstAssignedStudentFairAccessCriteria.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No student fair access criterias assigned...</label>
		</div>
	</div>
</div>

<!--Unassigned-->
<div class="main-action-group" *ngIf="rStudentFairAccess == true">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-assigned">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onAssignSFA()" [disabled]="isViewOnly == true">Assign</button>
			<img class="info-img" (click)="onToggleInfo6()" src="assets/images/info-24.png" />
			<label class="button-body-assigned-text" style="margin-left: 25px">Student Fair Access Criteria</label>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo6 == true ? 'block' : 'none'">
			<label>&#9900; Total Student Fair Access Criteria: {{ lstUnassignedStudentFairAccessCriteria.length }}</label
			><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 				 -->
		<!-- Display Actions -->
		<!-- 				 -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtActions
				[value]="lstUnassignedStudentFairAccessCriteria"
				[paginator]="true"
				[(rows)]="pagerows6"
				[(first)]="pagefirst6"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				[(loading)]="isBusy"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedUnassignedStudentFairAccess"
				dataKey="StudentFairAccessCriteriaID"
				(onSort)="onHandleSort6($event)"
				(onRowSelect)="onRowSelect6($event)"
				(onRowUnselect)="onRowUnselect6($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th pSortableColumn="StudentFairAccessCriteriaDesc">Description<p-sortIcon field="StudentFairAccessCriteriaDesc"></p-sortIcon></th>
						<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Used By<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rSFA>
					<tr [pSelectableRow]="rSFA">
						<td>
							<div class="table-data-Desc">
								{{ rSFA.StudentFairAccessCriteriaDesc }}
							</div>
						</td>

						<td>
							<div class="table-data-Desc">
								{{ rSFA.SchoolsDesc }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						  -->
		<!-- Display When No Actions  -->
		<!-- 						  -->
		<div style="padding: 20px" [style.display]="lstUnassignedStudentFairAccessCriteria.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No student fair access criterias configured...</label>
		</div>
	</div>
</div>

<!-------------------------------------------------------------->

<!------------------------------------------------------------------------------------------------------------------------------->

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddUpdate()" [disabled]="isBusy == true || isViewOnly == true">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
